import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle px-4 md:px-6 lg:px-8" };
const _hoisted_3 = { class: "flex justify-between items-center mb-2" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg" }, "Contract Types", -1);
const _hoisted_5 = { class: "my-2" };
const _hoisted_6 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_8 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContractManagement',
    props: {
        contracts: { default: () => [] }
    },
    emits: ["openModal"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const handleClickContract = (contract) => {
            emit('openModal', { type: 'contract', configData: contract });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('openModal')), ["prevent"]))
                            }, "Add Contract Type")
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("table", _hoisted_7, [
                            _createElementVNode("tbody", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contracts, (contract) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: contract.ContractType
                                    }, [
                                        _createElementVNode("td", {
                                            class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline cursor-pointer",
                                            onClick: _withModifiers(($event) => (handleClickContract(contract)), ["prevent"])
                                        }, [
                                            _createTextVNode(_toDisplayString(contract.ContractType) + " ", 1),
                                            (!contract.LKStatus)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Inactive"))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_9)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
